/* ARCK policy page accordions
 * Converts h4.arck-acc-toggle elements (or any h4 with cursor:pointer styling
 * inside .rte) into click-to-expand accordions on /policies/* pages.
 * Required because Shopify's policy editor strips <details>/<summary> on render.
 */
(function () {
  if (!/\/policies\//.test(location.pathname)) return;

  // Inject CSS override: expand the policy page container on desktop so the 4-card
  // quick-facts grid + hero use more horizontal space.
  // Targets: Shopify's built-in policy template container + override my inline max-width:900px
  // on the outer div in the policy body.
  (function injectStyles() {
    var css = [
      '@media (min-width: 990px) {',
      '  body.template-policy .shopify-policy__container {',
      '    max-width: 1240px !important;',
      '  }',
      '  body.template-policy .shopify-policy__body .rte > div[style*="max-width:900px"] {',
      '    max-width: 1200px !important;',
      '  }',
      '  body.template-policy .shopify-policy__body .rte > div[style*="max-width: 900px"] {',
      '    max-width: 1200px !important;',
      '  }',
      '}'
    ].join('\n');
    var s = document.createElement('style');
    s.setAttribute('data-arck-policy', 'true');
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  })();

  function init() {
    // Primary selector
    var toggles = Array.prototype.slice.call(document.querySelectorAll('h4.arck-acc-toggle'));
    // Fallback: if class got stripped, detect by inline cursor:pointer style on h4 inside .rte
    if (toggles.length === 0) {
      toggles = Array.prototype.filter.call(document.querySelectorAll('.rte h4'), function (h) {
        var s = h.getAttribute('style') || '';
        return /cursor\s*:\s*pointer/i.test(s);
      });
    }
    if (toggles.length === 0) return;

    toggles.forEach(function (h) {
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');

      var body = (h.parentNode && h.parentNode.querySelector('.arck-acc-body'))
              || (h.nextElementSibling && h.nextElementSibling.tagName === 'DIV' ? h.nextElementSibling : null);
      if (!body) return;

      // Determine starting state from inline style
      var startsOpen = /display\s*:\s*block/i.test(body.getAttribute('style') || '');
      h.setAttribute('aria-expanded', startsOpen ? 'true' : 'false');

      var icon = h.querySelector('span.arck-acc-icon') || h.querySelector('span:last-child');

      function toggle() {
        var isOpen = h.getAttribute('aria-expanded') === 'true';
        body.style.display = isOpen ? 'none' : 'block';
        h.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (icon) icon.textContent = isOpen ? '+' : '−';
      }

      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
